var _defs, _g, _path, _path2, _g2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 986.603,
    height: 424.442,
    viewBox: "0 0 986.603 424.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -79.46,
    y1: -23.488,
    x2: -78.608,
    y2: -23.488,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#000046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -132.637,
    y1: -41.461,
    x2: -131.816,
    y2: -41.461,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -407.553,
    y1: -73.97,
    x2: -407.451,
    y2: -72.477,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -406.15,
    y1: -73.692,
    x2: -406.049,
    y2: -72.199,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -412.27,
    y1: -74.929,
    x2: -412.168,
    y2: -73.436,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -410.679,
    y1: -74.611,
    x2: -410.577,
    y2: -73.118,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -404.804,
    y1: -73.415,
    x2: -404.703,
    y2: -71.923,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -403.464,
    y1: -73.138,
    x2: -403.362,
    y2: -71.645,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7060",
    "data-name": "Group 7060",
    transform: "translate(-451.092 -164.676)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843",
    transform: "translate(1043.76 164.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6987",
    "data-name": "Path 6987",
    d: "M302.12,100.347a11.476,11.476,0,0,1,12.26-8.6,11.661,11.661,0,0,1,1.676.294,11.471,11.471,0,1,1-13.936,8.3Z",
    transform: "translate(-247.885 -37.809)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    d: "M281.809,129.585l-.011,14.886a1.023,1.023,0,0,0,.688.963l11.721,4.05a53.994,53.994,0,0,0,6.694,16.181l-5.442,11.152a1.019,1.019,0,0,0,.194,1.168l10.517,10.531a1.024,1.024,0,0,0,1.168.2l11.157-5.426a54.109,54.109,0,0,0,16.173,6.718l4.034,11.726a1.024,1.024,0,0,0,.963.688l14.883.008a1.024,1.024,0,0,0,.966-.685l4.05-11.721a54.022,54.022,0,0,0,16.181-6.694l11.152,5.442a1.019,1.019,0,0,0,1.166-.194L398.6,178.058a1.024,1.024,0,0,0,.2-1.168l-5.429-11.157a54.028,54.028,0,0,0,6.718-16.173l11.726-4.034a1.019,1.019,0,0,0,.688-.963l.011-14.883a1.021,1.021,0,0,0-.685-.966l-11.721-4.05a54.1,54.1,0,0,0-6.7-16.181l5.442-11.152a1.019,1.019,0,0,0-.194-1.168L388.136,85.632a1.019,1.019,0,0,0-1.166-.2l-11.16,5.429a54.058,54.058,0,0,0-16.17-6.721L355.6,72.419a1.014,1.014,0,0,0-.963-.688l-14.883-.011a1.02,1.02,0,0,0-.963.685l-4.05,11.721a54.084,54.084,0,0,0-16.184,6.7l-11.149-5.445a1.024,1.024,0,0,0-1.168.2L295.712,96.09a1.02,1.02,0,0,0-.2,1.168l5.426,11.16a54.051,54.051,0,0,0-6.718,16.17L282.5,128.622A1.023,1.023,0,0,0,281.809,129.585ZM320.957,110.8a36.79,36.79,0,0,1,57.552,44.941.872.872,0,0,1-1.616-.537.843.843,0,0,1,.119-.359,34.948,34.948,0,0,0,4.8-14.435,35.443,35.443,0,0,0,.181-3.556,35,35,0,1,0-27.643,34.234.876.876,0,0,1,1.036.669.864.864,0,0,1,.013.275.876.876,0,0,1-.685.764l-.432.089-.224.046-.078.013a36.966,36.966,0,0,1-5.855.653c-.4.013-.8.019-1.2.019q-1.906,0-3.775-.194a36.789,36.789,0,0,1-32.985-36.62,37.4,37.4,0,0,1,.192-3.78A36.5,36.5,0,0,1,320.957,110.8Zm24.688,41.158a15.627,15.627,0,0,1-2.164-.383,14.948,14.948,0,1,1,2.164.383Z",
    transform: "translate(-281.798 -71.72)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842",
    transform: "translate(120.247 83.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    d: "M326.369,141.365l-.005,9.959a.68.68,0,0,0,.459.645l7.844,2.712a36.146,36.146,0,0,0,4.479,10.828l-3.643,7.46a.683.683,0,0,0,.132.782l7.037,7.045a.678.678,0,0,0,.78.132l7.469-3.632a36.182,36.182,0,0,0,10.82,4.5l2.7,7.846a.68.68,0,0,0,.645.459l9.959.008a.68.68,0,0,0,.645-.459L378.4,181.8a36.151,36.151,0,0,0,10.828-4.482l7.461,3.643a.687.687,0,0,0,.782-.13l7.048-7.037a.686.686,0,0,0,.13-.782l-3.629-7.466a36.262,36.262,0,0,0,4.5-10.822l7.846-2.7a.68.68,0,0,0,.459-.645l.008-9.959a.686.686,0,0,0-.459-.648l-7.844-2.709a36.186,36.186,0,0,0-4.479-10.828l3.64-7.463a.677.677,0,0,0-.13-.78l-7.037-7.048a.686.686,0,0,0-.782-.132l-7.466,3.632a36.119,36.119,0,0,0-10.822-4.5l-2.7-7.846a.683.683,0,0,0-.645-.461l-9.959-.005a.68.68,0,0,0-.645.459l-2.712,7.841a36.224,36.224,0,0,0-10.828,4.482l-7.463-3.643a.678.678,0,0,0-.78.132l-7.048,7.037a.682.682,0,0,0-.132.78l3.632,7.469a36.175,36.175,0,0,0-4.5,10.82l-7.846,2.7A.683.683,0,0,0,326.369,141.365Zm25.657-13.11a25.378,25.378,0,0,1,43.311,17.978,25.384,25.384,0,0,1-3.607,13.03,1.346,1.346,0,0,1-2.493-.831,1.291,1.291,0,0,1,.184-.556,22.687,22.687,0,1,0-42.027-14.009,23.032,23.032,0,0,0-.119,2.331,22.538,22.538,0,0,0,6.632,16.046l.111.108.035.035a22.991,22.991,0,0,0,15.625,5.976h-1.125v.451a22.99,22.99,0,0,0,5.5-.464A1.758,1.758,0,0,1,376,169.4c.03.14.21.294.2.432a1.269,1.269,0,0,1-.971,1.185c-.076.016-.108.035-.183.051a25.373,25.373,0,0,1-23.015-42.817Zm23.285,26.874a10.191,10.191,0,0,1-15.1-11.254,10.191,10.191,0,1,1,15.1,11.254Z",
    transform: "translate(-326.364 -102.643)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    d: "M340.852,127.407a7.5,7.5,0,0,1,7.2-11.3,8.02,8.02,0,0,1,1.085.192,7.5,7.5,0,1,1-8.281,11.106Z",
    transform: "translate(-303.56 -79.838)",
    fill: "#dde4eb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7053",
    "data-name": "Path 7053",
    d: "M628.564,382.066H211.7a3.9,3.9,0,0,1-3.9-3.906V127.816a23.882,23.882,0,0,1,23.842-23.873H608.622a23.887,23.887,0,0,1,23.849,23.873V378.16A3.9,3.9,0,0,1,628.564,382.066Z",
    transform: "translate(549.156 167.941)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7055",
    "data-name": "Path 7055",
    d: "M608.136,104H231.154C218.005,104,208,114.513,208,127.679V378.022c0,2.159,1.059,5.231,3.211,5.231H628.079c2.159,0,5.612-3.072,5.612-5.231V127.679C633.691,114.513,621.285,104,608.136,104Zm15.338,272.442H214.811V127.679c0-8.861,7.5-13.462,16.343-13.462H608.136c8.844,0,15.338,4.6,15.338,13.462Z",
    transform: "translate(548.445 166.078)",
    fill: "#dde4eb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865",
    transform: "translate(451.092 182.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M88,145.518a5.829,5.829,0,1,1,5.828-5.828A5.835,5.835,0,0,1,88,145.518ZM88,136a3.692,3.692,0,1,0,3.694,3.694A3.7,3.7,0,0,0,88,136Z",
    transform: "translate(-82.172 30.427)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M176.9,174.551a5.828,5.828,0,1,1,5.831-5.825A5.832,5.832,0,0,1,176.9,174.551Zm0-9.519a3.692,3.692,0,1,0,3.694,3.694A3.7,3.7,0,0,0,176.9,165.032Z",
    transform: "translate(68.794 79.736)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856",
    transform: "translate(174.256 296.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M150.555,199.614a1.067,1.067,0,0,1-1.068-1.069V183.8a1.068,1.068,0,0,1,2.137,0v14.743A1.067,1.067,0,0,1,150.555,199.614Z",
    transform: "translate(-142.116 -182.734)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M162.566,187.6H147.823a1.068,1.068,0,1,1,0-2.137h14.743a1.068,1.068,0,0,1,0,2.137Z",
    transform: "translate(-146.755 -178.095)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857",
    transform: "translate(141.247 81.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M138.321,120.075a1.067,1.067,0,0,1-1.068-1.068v-14.74a1.068,1.068,0,1,1,2.137,0v14.74A1.067,1.067,0,0,1,138.321,120.075Z",
    transform: "translate(-129.882 -103.198)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M150.332,108.064H135.59a1.067,1.067,0,1,1,0-2.134h14.743a1.067,1.067,0,1,1,0,2.134Z",
    transform: "translate(-134.521 -98.559)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858",
    transform: "translate(92.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M120.225,89.848a1.067,1.067,0,0,1-1.068-1.068V74.039a1.068,1.068,0,0,1,2.137,0V88.78A1.067,1.067,0,0,1,120.225,89.848Z",
    transform: "translate(-111.788 -72.971)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    d: "M132.235,77.837H117.492a1.067,1.067,0,0,1,0-2.134h14.743a1.067,1.067,0,1,1,0,2.134Z",
    transform: "translate(-116.426 -68.332)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M247.765,175.671H100.245a5.735,5.735,0,0,1,0-11.47h147.52a5.735,5.735,0,1,1,0,11.47Zm-147.52-9.336a3.6,3.6,0,0,0,0,7.2h147.52a3.6,3.6,0,0,0,0-7.2Z",
    transform: "translate(-61.218 81.953)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M211.615,138.958H157.082a2.336,2.336,0,0,1-2.334-2.334h0a2.335,2.335,0,0,1,2.334-2.334h54.533a2.333,2.333,0,0,1,2.334,2.334h0A2.335,2.335,0,0,1,211.615,138.958Z",
    transform: "translate(41.075 31.159)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    d: "M158.712,155.706H117a2.332,2.332,0,0,1-2.334-2.331h0A2.333,2.333,0,0,1,117,151.041h41.714a2.333,2.333,0,0,1,2.334,2.334h0A2.332,2.332,0,0,1,158.712,155.706Z",
    transform: "translate(-26.995 59.605)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864",
    transform: "translate(63.496 101.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    d: "M123.56,152.754a.718.718,0,0,1-.72-.7V136.564a.7.7,0,0,1,.7-.7h15.415a.7.7,0,0,1,.531.246.729.729,0,0,1-.016.971l-15.415,15.466A.7.7,0,0,1,123.56,152.754Zm.68-15.488v13.11l13.07-13.11Z",
    transform: "translate(-76.607 -67.494)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    d: "M152.64,195.784H106.407a.7.7,0,0,1-.7-.7V111.226a.7.7,0,0,1,.7-.7h61.648a.7.7,0,0,1,.7.7v68.369a.7.7,0,0,1-.7.7H153.339v14.786A.7.7,0,0,1,152.64,195.784Zm-45.534-1.4h44.833V179.595a.7.7,0,0,1,.7-.7h14.713V111.927H107.105ZM123.637,179.7a3.209,3.209,0,0,1-2.741-1.538l-2.221-3.683a3.2,3.2,0,0,1,1.079-4.385l25.8-15.622a.742.742,0,0,1,.437-.1l7.2.769a.7.7,0,0,1,.591.917l-2.391,7.166a.682.682,0,0,1-.3.375L127.5,177.889l-.076.04-2.132,1.3A3.193,3.193,0,0,1,123.637,179.7Zm22.441-23.906-25.6,15.5a1.8,1.8,0,0,0-.6,2.455l2.221,3.686a1.8,1.8,0,0,0,2.469.6l2.191-1.338a.543.543,0,0,1,.086-.049l23.3-14.111,2.032-6.1Z",
    transform: "translate(-105.705 -110.524)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    d: "M125.857,136.107a.7.7,0,0,1-.6-.337l-4.808-7.933a.7.7,0,0,1,.008-.739.715.715,0,0,1,.666-.321l7.2.769a.7.7,0,0,1,.591.917l-2.391,7.166a.7.7,0,0,1-.586.472Zm-3.475-7.787,3.289,5.426,1.635-4.9Z",
    transform: "translate(-80.838 -82.929)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016",
    "data-name": "Path 7016",
    d: "M115.611,147.9a.719.719,0,0,1-.61-.337l-2.409-3.961a.695.695,0,0,1,.318-1l23.528-14.257a.7.7,0,0,1,.963.237l2.4,3.966a.7.7,0,0,1-.237.961L115.975,147.8A.72.72,0,0,1,115.611,147.9Zm-1.454-4.417,1.681,2.76,22.4-13.569-1.673-2.768Z",
    transform: "translate(-94.182 -80.433)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7017",
    "data-name": "Path 7017",
    d: "M114.71,146.44a.722.722,0,0,1-.612-.34l-2.38-3.95a.712.712,0,0,1-.108-.472.693.693,0,0,1,.326-.513l23.6-14.29a.7.7,0,0,1,.961.237l2.409,3.966a.711.711,0,0,1,.081.529.7.7,0,0,1-.318.432l-23.6,14.3A.686.686,0,0,1,114.71,146.44ZM113.261,142l1.678,2.782,22.406-13.575-1.681-2.768Z",
    transform: "translate(-95.688 -82.931)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7018",
    "data-name": "Path 7018",
    d: "M115.763,143.109a3.209,3.209,0,0,1-2.741-1.538l-2.221-3.683a3.2,3.2,0,0,1,1.079-4.385l2.2-1.333a.7.7,0,0,1,.872.113.809.809,0,0,1,.1.135l4.8,7.919a.7.7,0,0,1-.229.958l-2.2,1.349A3.193,3.193,0,0,1,115.763,143.109Zm-1.557-9.379-1.6.974a1.8,1.8,0,0,0-.6,2.455l2.221,3.686a1.8,1.8,0,0,0,2.469.6l1.6-.974-1.867-3.068,0,0Z",
    transform: "translate(-97.831 -73.936)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7019",
    "data-name": "Path 7019",
    d: "M152.64,195.784H106.407a.7.7,0,0,1-.7-.7V111.226a.7.7,0,0,1,.7-.7h61.648a.7.7,0,0,1,.7.7v68.369a.7.7,0,0,1-.7.7H153.339v14.786A.7.7,0,0,1,152.64,195.784Zm-45.534-1.4h44.833V179.595a.7.7,0,0,1,.7-.7h14.713V111.927H107.105Z",
    transform: "translate(-105.705 -110.524)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7020",
    "data-name": "Path 7020",
    d: "M123.548,152.739a.712.712,0,0,1-.5-.205.7.7,0,0,1,0-.99l15.415-15.466a.7.7,0,0,1,.993.988l-15.415,15.466A.7.7,0,0,1,123.548,152.739Z",
    transform: "translate(-76.594 -67.48)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7021",
    "data-name": "Path 7021",
    d: "M151.515,117.649H110a.7.7,0,1,1,0-1.4h41.517a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-99.605 -100.802)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7022",
    "data-name": "Path 7022",
    d: "M151.515,121.781H110a.7.7,0,0,1,0-1.4h41.517a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-99.605 -93.79)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7023",
    "data-name": "Path 7023",
    d: "M151.515,125.9H110a.7.7,0,1,1,0-1.4h41.517a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-99.605 -86.79)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7024",
    "data-name": "Path 7024",
    d: "M115.763,152.1a3.209,3.209,0,0,1-2.741-1.538L110.8,146.88a3.2,3.2,0,0,1,1.079-4.385l25.8-15.622a.742.742,0,0,1,.437-.1l7.2.769a.7.7,0,0,1,.591.917l-2.391,7.166a.682.682,0,0,1-.3.375l-23.587,14.289-.076.04-2.132,1.3A3.193,3.193,0,0,1,115.763,152.1ZM138.2,128.2l-25.6,15.5a1.8,1.8,0,0,0-.6,2.455l2.221,3.686a1.8,1.8,0,0,0,2.469.6l2.191-1.338a.469.469,0,0,1,.089-.049l23.3-14.111,2.032-6.1Z",
    transform: "translate(-97.831 -82.928)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7025",
    "data-name": "Path 7025",
    d: "M117.114,141.4a.7.7,0,0,1-.459-.17.711.711,0,0,1-.151-.173l-4.8-7.925a.7.7,0,1,1,1.2-.723l4.751,7.844a.7.7,0,0,1-.542,1.147Z",
    transform: "translate(-95.685 -73.929)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7026",
    "data-name": "Path 7026",
    d: "M125.857,136.107a.7.7,0,0,1-.6-.337l-4.808-7.933a.7.7,0,1,1,1.2-.726l4.808,7.933a.7.7,0,0,1-.6,1.063Z",
    transform: "translate(-80.838 -82.929)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7027",
    "data-name": "Path 7027",
    d: "M113.2,143.943a.7.7,0,0,1-.364-1.3l23.6-14.3a.7.7,0,1,1,.726,1.2l-23.6,14.3A.682.682,0,0,1,113.2,143.943Z",
    transform: "translate(-94.175 -80.434)",
    fill: "#dde4eb"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869",
    transform: "translate(1182.672 212.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7028",
    "data-name": "Path 7028",
    d: "M359.139,156.961a5.829,5.829,0,1,1,5.828-5.828A5.835,5.835,0,0,1,359.139,156.961Zm0-9.522a3.692,3.692,0,1,0,3.694,3.694A3.7,3.7,0,0,0,359.139,147.439Z",
    transform: "translate(-353.311 18.984)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7029",
    "data-name": "Path 7029",
    d: "M448.038,186a5.829,5.829,0,1,1,5.831-5.828A5.835,5.835,0,0,1,448.038,186Zm0-9.522a3.692,3.692,0,1,0,3.694,3.694A3.7,3.7,0,0,0,448.038,176.475Z",
    transform: "translate(-202.345 68.293)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866",
    transform: "translate(174.256 296.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7030",
    "data-name": "Path 7030",
    d: "M421.694,211.055a1.067,1.067,0,0,1-1.068-1.068V195.244a1.068,1.068,0,0,1,2.137,0v14.743A1.067,1.067,0,0,1,421.694,211.055Z",
    transform: "translate(-413.255 -194.178)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7031",
    "data-name": "Path 7031",
    d: "M433.705,199.046H418.962a1.069,1.069,0,0,1,0-2.137h14.743a1.069,1.069,0,0,1,0,2.137Z",
    transform: "translate(-417.894 -189.54)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867",
    transform: "translate(141.247 81.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7032",
    "data-name": "Path 7032",
    d: "M409.46,131.518a1.067,1.067,0,0,1-1.068-1.068v-14.74a1.068,1.068,0,0,1,2.137,0v14.74A1.068,1.068,0,0,1,409.46,131.518Z",
    transform: "translate(-401.021 -114.641)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7033",
    "data-name": "Path 7033",
    d: "M421.471,119.507H406.728a1.067,1.067,0,1,1,0-2.134h14.743a1.067,1.067,0,1,1,0,2.134Z",
    transform: "translate(-405.66 -110.002)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868",
    transform: "translate(92.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7034",
    "data-name": "Path 7034",
    d: "M391.364,101.291a1.067,1.067,0,0,1-1.068-1.068V85.482a1.068,1.068,0,0,1,2.137,0v14.74A1.067,1.067,0,0,1,391.364,101.291Z",
    transform: "translate(-382.927 -84.414)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7035",
    "data-name": "Path 7035",
    d: "M403.374,89.28H388.631a1.067,1.067,0,0,1,0-2.134h14.743a1.067,1.067,0,1,1,0,2.134Z",
    transform: "translate(-387.565 -79.775)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7036",
    "data-name": "Path 7036",
    d: "M518.906,187.114H371.384a5.735,5.735,0,0,1,0-11.47H518.906a5.735,5.735,0,0,1,0,11.47Zm-147.523-9.336a3.6,3.6,0,0,0,0,7.2H518.906a3.6,3.6,0,0,0,0-7.2Z",
    transform: "translate(-332.357 70.51)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7037",
    "data-name": "Path 7037",
    d: "M482.754,150.4H428.221a2.336,2.336,0,0,1-2.334-2.334h0a2.335,2.335,0,0,1,2.334-2.334h54.533a2.333,2.333,0,0,1,2.334,2.334h0A2.335,2.335,0,0,1,482.754,150.4Z",
    transform: "translate(-230.064 19.716)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7038",
    "data-name": "Path 7038",
    d: "M429.851,167.149H388.137a2.332,2.332,0,0,1-2.334-2.331h0a2.333,2.333,0,0,1,2.334-2.334h41.714a2.333,2.333,0,0,1,2.334,2.334h0A2.332,2.332,0,0,1,429.851,167.149Z",
    transform: "translate(-298.134 48.162)",
    fill: "#dde4eb"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879",
    transform: "translate(1222.939 530.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7039",
    "data-name": "Path 7039",
    d: "M438.946,254.2h-67.5a3.218,3.218,0,0,1-3.208-3.219V205.462a3.218,3.218,0,0,1,3.208-3.219h67.5a3.221,3.221,0,0,1,3.214,3.219v45.524A3.221,3.221,0,0,1,438.946,254.2Zm-67.5-50.745a2,2,0,0,0-1.994,2v45.524a2,2,0,0,0,1.994,2h67.5a2,2,0,0,0,2-2V205.462a2,2,0,0,0-2-2Z",
    transform: "translate(-368.235 -202.243)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871",
    transform: "translate(0 9.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7040",
    "data-name": "Path 7040",
    d: "M441.552,206.9h-72.71a.607.607,0,1,1,0-1.214h72.71a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-368.235 -205.689)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872",
    transform: "translate(3.06 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7041",
    "data-name": "Path 7041",
    d: "M373.824,208.317h-3.848a.607.607,0,0,1-.607-.61V203.86a.606.606,0,0,1,.607-.607h3.848a.606.606,0,0,1,.607.607v3.848A.607.607,0,0,1,373.824,208.317Zm-3.24-1.217h2.633v-2.633h-2.633Z",
    transform: "translate(-369.369 -203.253)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873",
    transform: "translate(10.545 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7042",
    "data-name": "Path 7042",
    d: "M376.592,208.317H372.75a.607.607,0,0,1-.607-.61V203.86a.606.606,0,0,1,.607-.607h3.842a.609.609,0,0,1,.61.607v3.848A.609.609,0,0,1,376.592,208.317Zm-3.235-1.217h2.628v-2.633h-2.628Z",
    transform: "translate(-372.143 -203.253)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874",
    transform: "translate(18.024 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7043",
    "data-name": "Path 7043",
    d: "M379.367,208.317h-3.845a.607.607,0,0,1-.607-.61V203.86a.606.606,0,0,1,.607-.607h3.845a.606.606,0,0,1,.607.607v3.848A.607.607,0,0,1,379.367,208.317Zm-3.238-1.217h2.631v-2.633h-2.631Z",
    transform: "translate(-374.915 -203.253)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875",
    transform: "translate(11.715 17.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7044",
    "data-name": "Path 7044",
    d: "M388.434,234.691a.607.607,0,0,1-.389-.143L372.8,221.869a.608.608,0,0,1,0-.934l14.433-12a.607.607,0,0,1,.777.934L374.136,221.4l14.686,12.212a.608.608,0,0,1,.078.855A.6.6,0,0,1,388.434,234.691Z",
    transform: "translate(-372.577 -208.794)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876",
    transform: "translate(45.742 17.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7045",
    "data-name": "Path 7045",
    d: "M385.8,234.691a.609.609,0,0,1-.388-1.077L400.087,221.4l-13.863-11.535a.607.607,0,0,1,.777-.934l14.424,12a.6.6,0,0,1,0,.934l-15.242,12.679A.607.607,0,0,1,385.8,234.691Z",
    transform: "translate(-385.188 -208.794)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877",
    transform: "translate(28.733 14.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7046",
    "data-name": "Path 7046",
    d: "M379.491,239.128a.613.613,0,0,1-.273-.065.607.607,0,0,1-.27-.815l15.107-30.128a.607.607,0,0,1,1.085.545l-15.107,30.128A.609.609,0,0,1,379.491,239.128Z",
    transform: "translate(-378.884 -207.784)",
    fill: "#dde4eb"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13012",
    "data-name": "Path 13012",
    d: "M1.254-13.376C1.254-5.4,6.8.19,14.668.19,21.014.19,25.8-3.344,27.322-9.12H20.178A5.877,5.877,0,0,1,14.592-5.7c-3.99,0-6.726-2.964-6.726-7.676s2.736-7.676,6.726-7.676a5.877,5.877,0,0,1,5.586,3.42h7.144c-1.52-5.776-6.308-9.348-12.654-9.348C6.8-26.98,1.254-21.356,1.254-13.376Zm56.316-.038A13.3,13.3,0,0,0,43.928-27.056,13.389,13.389,0,0,0,30.21-13.414,13.42,13.42,0,0,0,43.928.266,13.358,13.358,0,0,0,57.57-13.414Zm-20.71,0c0-4.75,2.736-7.752,7.068-7.752,4.256,0,7.03,3,7.03,7.752,0,4.674-2.774,7.752-7.03,7.752C39.6-5.662,36.86-8.74,36.86-13.414ZM61.18,0h6.5V-16.036L73.682,0h5.244l5.966-16V0h6.5V-26.676H83.752L76.342-8.208,68.856-26.676H61.18ZM96.064,0h6.5V-26.676h-6.5ZM124.64-26.676v16.53l-10.868-16.53h-6.5V0h6.5V-16.454L124.64,0h6.5V-26.676Zm23.674-.3c-7.98,0-13.566,5.624-13.566,13.6S140.372.19,148.352.19a13.064,13.064,0,0,0,12.844-9.2v-6.042H147.06v4.788h8.246a6.391,6.391,0,0,1-6.46,4.712c-4.674,0-7.486-2.888-7.486-7.828,0-4.636,2.774-7.6,6.954-7.6a5.587,5.587,0,0,1,5.244,2.736h7.182C159.334-23.712,154.7-26.98,148.314-26.98ZM21.736,32.058c0-8.93-13.186-6.84-13.186-11.476,0-1.672,1.178-2.47,2.736-2.432a2.887,2.887,0,0,1,3.078,2.774h7.03c-.266-5.092-4.18-7.98-9.994-7.98-5.586,0-9.728,2.812-9.728,7.866-.076,9.462,13.262,6.8,13.262,11.742,0,1.558-1.216,2.508-3.116,2.508a3.059,3.059,0,0,1-3.306-3.04H1.6c.19,5.4,4.674,8.246,10.412,8.246C18.24,40.266,21.736,36.542,21.736,32.058Zm30.248-5.472A13.3,13.3,0,0,0,38.342,12.944,13.389,13.389,0,0,0,24.624,26.586a13.42,13.42,0,0,0,13.718,13.68A13.358,13.358,0,0,0,51.984,26.586Zm-20.71,0c0-4.75,2.736-7.752,7.068-7.752,4.256,0,7.03,3,7.03,7.752,0,4.674-2.774,7.752-7.03,7.752C34.01,34.338,31.274,31.26,31.274,26.586Zm50.578,0a13.68,13.68,0,0,0-27.36,0,13.68,13.68,0,1,0,27.36,0Zm-20.71,0c0-4.75,2.736-7.752,7.068-7.752,4.256,0,7.03,3,7.03,7.752,0,4.674-2.774,7.752-7.03,7.752C63.878,34.338,61.142,31.26,61.142,26.586Zm41.686-13.262v16.53L91.96,13.324h-6.5V40h6.5V23.546L102.828,40h6.5V13.324Z",
    transform: "translate(818 409.112)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7058",
    "data-name": "Group 7058",
    transform: "translate(-366.385 -189.05)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M1335.2,1330.944,1323,1349.98l6.812,4.365a3.99,3.99,0,0,0,5.5-1.216l7.9-12.327a3.985,3.985,0,0,0-1.2-5.492Z",
    transform: "translate(166.164 -692.612)",
    fill: "#536dfe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M1219.492,1285.907l.649.416,12.194-19.031-.649-.416a11.3,11.3,0,0,0-15.612,3.419h0A11.3,11.3,0,0,0,1219.492,1285.907Z",
    transform: "translate(216.35 -662.21)",
    fill: "#13258d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M1303.248,1306.318l-14.965,23.357,15.091,9.669a2.63,2.63,0,0,0,3.632-.784l12.13-18.932a2.644,2.644,0,0,0-.8-3.64Z",
    transform: "translate(182.192 -681.243)",
    fill: "#536dfe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M1285,1354.721l-12.131,18.931a5.271,5.271,0,0,0,8.875,5.687l12.131-18.932Z",
    transform: "translate(189.687 -703.588)",
    fill: "#536dfe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M1228.51,1225.414l-37.688,58.82,52.239,8.451,14.965-23.357Z",
    transform: "translate(227.182 -643.895)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M1203.754,1297.754l-12.5,19.516,52.239,8.451,5.4-8.434Z",
    transform: "translate(226.984 -677.29)",
    fill: "#8a8ba9",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M1223.131,1272.663l-8.655,13.508,45.138,19.533,4.806-7.5Z",
    transform: "translate(216.262 -665.707)",
    fill: "#c1c2d1",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    d: "M1.285,0h0A1.283,1.283,0,0,1,2.568,1.283V69.8a1.285,1.285,0,0,1-1.285,1.285h0A1.284,1.284,0,0,1,0,69.8V1.285A1.285,1.285,0,0,1,1.285,0Z",
    transform: "matrix(-0.842, -0.54, 0.54, -0.842, 1418.756, 641.039)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M1295.109,1329.914l-6.826,10.653,15.091,9.669a2.63,2.63,0,0,0,3.632-.784l5.413-8.448Z",
    transform: "translate(182.192 -692.136)",
    opacity: 0.16,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M1327.53,1353.166l-4.531,7.072,6.812,4.365a3.99,3.99,0,0,0,5.5-1.216l2.377-3.711Z",
    transform: "translate(166.164 -702.87)",
    opacity: 0.19,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M1285,1354.721l-12.131,18.931a5.263,5.263,0,0,0,7.58,7.053,5.066,5.066,0,0,1-1.762-.708,5.265,5.265,0,0,1-1.6-7.268l10.484-16.362Z",
    transform: "translate(189.687 -703.588)",
    fill: "#c7c9d6",
    opacity: 0.76,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M1330.575,1333.537h0a.514.514,0,0,0,.71-.156l3.724-5.812a.514.514,0,0,0-.156-.709h0a.514.514,0,0,0-.71.156l-3.724,5.812A.515.515,0,0,0,1330.575,1333.537Z",
    transform: "translate(162.777 -690.688)",
    opacity: 0.09,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M1325.076,1330.014h0a.514.514,0,0,0,.71-.155l3.724-5.812a.514.514,0,0,0-.156-.71h0a.514.514,0,0,0-.71.156l-3.724,5.812A.514.514,0,0,0,1325.076,1330.014Z",
    transform: "translate(165.316 -689.063)",
    opacity: 0.09,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M1347.874,1351.638h0a.514.514,0,0,0,.709-.155l3.724-5.812a.514.514,0,0,0-.155-.71h0a.515.515,0,0,0-.71.155l-3.724,5.812A.514.514,0,0,0,1347.874,1351.638Z",
    transform: "translate(154.791 -699.045)",
    opacity: 0.09,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M1341.547,1347.585h0a.514.514,0,0,0,.71-.156l3.724-5.812a.513.513,0,0,0-.155-.709h0a.515.515,0,0,0-.71.156l-3.724,5.812A.514.514,0,0,0,1341.547,1347.585Z",
    transform: "translate(157.711 -697.174)",
    opacity: 0.09,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M1319.578,1326.491h0a.514.514,0,0,0,.71-.156l3.724-5.812a.514.514,0,0,0-.155-.71h0a.514.514,0,0,0-.71.156l-3.724,5.812A.514.514,0,0,0,1319.578,1326.491Z",
    transform: "translate(167.853 -687.436)",
    opacity: 0.09,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M1314.079,1322.967h0a.514.514,0,0,0,.71-.155l3.724-5.812a.514.514,0,0,0-.156-.71h0a.514.514,0,0,0-.71.156l-3.724,5.811A.514.514,0,0,0,1314.079,1322.967Z",
    transform: "translate(170.39 -685.809)",
    opacity: 0.09,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M1201.385,1153.678c-4.53-5.82-16.549-17.434-13.554-26.862s16-12.373,13.269.9S1208.4,1162.686,1201.385,1153.678Z",
    transform: "translate(228.781 -594.648)",
    fill: "#24dcae"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M1241.193,1181.881c-4.109-6.124-15.283-18.554-11.632-27.749s16.832-11.217,13.173,1.829S1247.553,1191.361,1241.193,1181.881Z",
    transform: "translate(209.633 -607.561)",
    fill: "#536dfe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M1160.877,1334.8c-5.081.385-16.6-.372-20.037,5.539s4.981,11.769,10.5,4.208S1168.742,1334.207,1160.877,1334.8Z",
    transform: "translate(250.624 -694.357)",
    fill: "#fcb151"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M1216.535,1217.645q-.361-.834-.809-1.637c-1.222-2.189-4.63-7.91-6.445-7.064-2.237,1.043-2.862,5.737-.56,8.654s8.4,10.458,9.88,9.079C1219.8,1225.56,1217.464,1219.795,1216.535,1217.645Z",
    transform: "translate(219.588 -636.253)",
    fill: "#fcb151"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M1150.319,1274.575c-.7,2.47,4.25,5.637,7.86,5.815s11.077,1.048,11.04-1.055C1169.188,1277.631,1152.534,1268.855,1150.319,1274.575Z",
    transform: "translate(245.911 -665.707)",
    fill: "#fc7886"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M1127.427,1312.006a142.756,142.756,0,0,0-22.342,2.529c-12.786,2.414-27.544-2.307-18.636-12.574S1141.037,1312.5,1127.427,1312.006Z",
    transform: "translate(276.621 -677.916)",
    fill: "#089ecb"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7059",
    "data-name": "Group 7059",
    transform: "translate(0.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887",
    transform: "translate(731 543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7056",
    "data-name": "Path 7056",
    d: "M646.379,229.435h-416.9c-16.03,0-29.076-10.353-29.076-23.066V187.223a3.908,3.908,0,0,1,3.9-3.906H671.536a3.906,3.906,0,0,1,3.906,3.906v19.146C675.442,219.082,662.406,229.435,646.379,229.435Z",
    transform: "translate(-200.405 -183.317)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615",
    "data-name": "Ellipse 615",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(963 560)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.f3c75d31.svg";
export { ForwardRef as ReactComponent };